import { Link } from "react-router-dom";
import YoutubeEmbed from "./YoutubeEmbed";
import styles from "./About.module.css";

const About = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.aboutContainer}>
          <div className={styles.aboutImg}>
            <YoutubeEmbed embedId="ZPs3URGs0KQ" />
          </div>
          <div className={styles.aboutText}>
            <h3>ABOUT US</h3>
            <h1>Innovative Way To Learn</h1>
            <p>
              We focus on preparing our candidates to be workforce ready.
              Well-rounded education, combining theoretical knowledge with
              practical skills. Candidates receive a strong foundation in
              academic principles and real-world applications.
            </p>
            <Link to="/courses" className={`primary-btn ${styles.aboutBtn}`}>
              Explore More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
